<template>
    <div class="text-muted mb-3">
        <b-row>
            <b-col>
                <p class="mb-1 ml-1 text-uppercase">
                    <small>
                        <i class="far fa-check-square"></i>
                        {{ 'Status da Meta' }}
                    </small>
                </p>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <div class="d-flex justify-content-between ml-2">
                    {{
                        target.status == 'active'
                            ? $t('targets.status.targetActived')
                            : $t('targets.status.targetCompleted')
                    }}
                    <b-dropdown
                        id="btn-target-status"
                        :disabled="!isAllowedToEdit"
                        :no-caret="true"
                        :text="$t('form.button.edit')"
                        variant="link"
                        size="sm"
                    >
                        <b-dropdown-item
                            id="btn-target-status-active"
                            @click="onClickEditStatus('active')"
                            >{{ $t('targets.status.active') }}</b-dropdown-item
                        >
                        <b-dropdown-item
                            id="btn-target-status-complete"
                            @click="onClickEditStatus('completed')"
                            >{{
                                $t('targets.status.completed')
                            }}</b-dropdown-item
                        >
                    </b-dropdown>
                </div>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import i18n from '@/i18n'
import Swal from 'sweetalert2'
import { updateTargetStatus } from './api'
import notification, { success, danger } from '@/lib/notification'
import { deleteConfirmationWithLoading } from '@/config/sweet-alert'

notification.init()

export default {
    name: 'Status',
    props: ['target', 'isAllowedToEdit'],
    data() {
        return {}
    },
    methods: {
        onClickEditStatus(status) {
            const text = i18n.t('targets.status.changeStatus', {
                status: i18n.t(`targets.status.${status}`).toLowerCase(),
            })
            return Swal({
                ...deleteConfirmationWithLoading,
                text,
                preConfirm: () => {
                    return updateTargetStatus(this.target.id, status)
                },
            })
                .then((response) => {
                    if (response.value) {
                        this.$emit('updated')
                        success(i18n.t('targets.status.updatedGoalStatus'))
                    }
                })
                .catch(() => {
                    danger()
                })
        },
    },
}
</script>
